import type { Asset } from "../model/asset.model";
import type { ReleaseCardModel } from "../components/HomeLanding/HomeLandingModel";

export function releaseCardToAsset(item: ReleaseCardModel): Asset {
  const durationPick = item.picks.find(
    (p) => p.label.toLowerCase() === "duration"
  );
  const tagParts = item.picks
    .filter((p) => p.label.toLowerCase() !== "duration")
    .map((p) => p.value)
    .filter(Boolean)
    .join(" • ");

  const parsedId = Number.parseInt(item.id, 10);
  const assetUploadId = Number.isFinite(parsedId) ? parsedId : undefined;

  return {
    id: item.id,
    assetUploadId,
    title: item.title,
    description: item.description ?? item.subtitle ?? "",
    thumbnailUrl: item.thumbnailSrc ?? "",
    tags: tagParts || "—",
    price: item.price ?? "Free",
    duration: durationPick?.value ?? "—",
  };
}
